import React, { Component } from 'react';
import * as GServ from '../services/GatewayService';
import { CircularProgress,Button, TextField } from '@material-ui/core';

class OTPDialogue extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSpinner:false,
            status: '',
            warning: '',
            showOTPInput: false,
            showContinueScreen: true,
            canSubmit: true,
            otpPlaceholder: 'One-Time-Pin',
            otp_value: '',
            newGwt: null,
        }
    }
    
    render() {
        return (
            <div>
                {this.state.showContinueScreen&&
                <div>                
                    <h3>Thank you...</h3>
                    <p>We now need to send you a <b>One-Time-Pin (OTP)</b> before we proceed, in order to validate your email address.<br/><br/>Your One-Time-Pin will be sent to: <b>{this.props.myMail}</b></p>

                    <Button 
                        variant='contained'
                        size='large'
                        color='primary'
                        type='submit'
                        id="Submit" 
                        disabled={!this.state.canSubmit}
                        onClick={this.continueOtp}
                    >
                        <span id="s1">Send my OTP</span>
                    </Button>
                    {/* <button id="Submit" className="button" disabled={!this.state.canSubmit} style={{verticalAlign:'middle'}} onClick={this.continueOtp}><span id="s1" >Send my OTP</span></button> */}
                </div>}

                {this.state.showOTPInput&&
                <div>
                    <p>Please enter the One-Time-Pin(OTP) we sent to <b>{this.props.myMail}</b></p>
                    <p><i>If the OTP doesn't appear in your inbox, you may need to check in your Spam Folder</i></p>
                    <form name="OTP" method="POST" onSubmit={this.submitHandler}>
                        
                        <TextField
                            variant='outlined'
                            type="number"
                            id="otp"
                            name="otp"
                            label={this.state.otpPlaceholder}
                            value={this.state.otp_value}
                            autoFocus={true}
                            
                            // onFocus={()=> this.setState({otpPlaceholder:'',status:''})}
                            // onBlur={()=> this.setState({otpPlaceholder:'One-Time-Pin',status:''})}
                            onChange={this.fieldHandler}
                            required
                            // InputProps={{pattern:"\d*",minLength:5,maxLength:5}}
                            // InputProps={{maxLength:5}}
                            autoComplete="off"
                            // minLength={5}
                            // maxLength={5}
                            disabled={!this.state.canSubmit}
                            style={{width:'25%', minWidth:'100px', marginTop:'10px'}}
                        />
                        <br/>
                        {/* <div className="prime_input">
                            <input type="text" id="otp" name="otp" placeholder={this.state.otpPlaceholder} value={this.state.otp_value} autoFocus={true} onFocus={()=> this.setState({otpPlaceholder:'',status:''})} onBlur={()=> this.setState({otpPlaceholder:'One-Time-Pin',status:''})} onChange={this.fieldHandler} required pattern="\d*" autoComplete="off" minLength={5} maxLength={5} disabled={!this.state.canSubmit}/>
                        </div> */}

                        <Button 
                            variant='contained'
                            color='primary'
                            size='large'
                            id="Submit"
                            disabled={!this.state.canSubmit}
                            type='submit'
                            style={{marginTop:'15px'}}
                        >
                            <span id="s1" >Submit</span>
                        </Button>
                        {/* <button id="Submit" className="button" style={{verticalAlign:'middle'}} disabled={!this.state.canSubmit}><span id="s1" >Submit</span></button> */}
                    </form>
                    {this.props.custom_otp_message&&
                    <p dangerouslySetInnerHTML={{__html: this.props.custom_otp_message}}></p>}
                </div>}

                <hr/>
                <span id="StatusBar" className="StatusBar">
                    {this.state.showSpinner&&<CircularProgress size={30} />}&nbsp;&nbsp;
                    {this.state.status}
                </span>
                <span className='warningMessage'>{this.state.warning}</span>
            </div>
        );
    }

    continueOtp = () => {
        this.setState({canSubmit:false,showSpinner:true,status:'Generating your One-Time-Pin...'});
        const dataObj = {
            fname: this.props.fname,
            lname: this.props.lname,
            mobile: this.props.mobile,
            contact_email: this.props.myMail,
        };

        GServ.generateOTP(this.props.gwt,dataObj)
        .then(otpReply => {
            // console.log('otpReply',otpReply);
            //check if result success
            if (otpReply.Result!=="Success"){throw otpReply.Message;}
            this.setState({showSpinner:false,showContinueScreen:false,showOTPInput:true,canSubmit:true,newGwt:otpReply.newGWT,status:''})
        }).catch(err => {
            console.log('Error caught @ Gserv.generateOTP return => ',err);
            this.setState({status:'',warning:'There was an error generating your OTP. If this problem persists, please contact us.',showSpinner:false,canSubmit:true});
        });
    }

    fieldHandler = (e) => {
       this.setState({otp_value:e.target.value.substring(0,5)});
    }

    submitHandler = (e) => {
        e.preventDefault();
        this.setState({canSubmit:false,showSpinner:true,status:'Verifying...'});
        // console.log('GWT',this.state.newGwt);
        // console.log('otp',this.state.otp_value);
        GServ.submitOTP(this.state.newGwt,this.state.otp_value)
        .then(submissionResult => {
            // console.log('submissionResult: ',submissionResult);
            if (submissionResult.Result !== "Success"){throw Error('OTP verification failure')}
            this.setState({status:'OTP Verified!',warning:'',showSpinner:false})
            //Close up and update parent here (don't forget newGwt!);
            //Now choose next step, based on whether we already have ID etc...
            // console.log('id_on_file status:',this.props.id_on_file);
            //If OTP verified proceed base on whether or not we have ID yet - 
            if (this.props.id_on_file){
                //Welcome back and check for active applications...
                this.props.setParentState({gwt:this.state.newGwt,fname:submissionResult.fname,lname:submissionResult.lname,mobile:submissionResult.mobile,form_title:submissionResult.Form_Title,form_url:submissionResult.Form_Url,form_min_age:submissionResult.Form_Min_Age,form_max_age:submissionResult.Form_Max_Age, user_status:submissionResult.UserStatus,form_token:submissionResult.Form_Token,showOTPDialogue:false,showCheckAppStatus:true});
            } else {
                //ID is not on file already, can proceed to capture ID num (may be an issue if we don't have mobile number and there is a duplicate etc.?)
                this.props.setParentState({gwt:this.state.newGwt,form_title:submissionResult.Form_Title,form_url:submissionResult.Form_Url,form_min_age:submissionResult.Form_Min_Age,form_max_age:submissionResult.Form_Max_Age, user_status:submissionResult.UserStatus,form_token:submissionResult.Form_Token,showOTPDialogue:false,showIDNum:true});
            }
       
        }).catch(err => {
            console.log('Error caught @ Gserv.submitOTP return => ',err);
            this.setState({status:'',warning:'There was an error verifying your OTP. If this problem persists, please contact us.',showSpinner:false,canSubmit:true,showIDNum:true});
        });
    }

}

export default OTPDialogue;